module.exports = __webpack_public_path__ + "static/img/3.dc3a3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 10